module.exports = __webpack_public_path__ + "img/img_throw_1@3x.91071ac1.png";